import { InjectionToken } from '@angular/core';

export interface LoyaltyConfig {
  baseUrl: string;
}

export const LOYALTY_CONFIG = new InjectionToken<LoyaltyConfig>('LOYALTY_CONFIG');
